<template>
    <div class="tab__pane">
        <div
            class="tab__pane-content"
            :class="{ 'collapsed': collapsed }"
            v-if="active">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    /**
     * Tab Pane Component
     */
    export default {
        name: 'tab_pane',
        props: {
            label: {
                type: String,
                required: true
            },
            labelValue: {
                required: false
            },
            collapsed: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data () {
            return {
                active: false
            }
        },
        created () {
            this.$parent.tabPanes.push(this)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/TabPane.vue